import { useEffect, useState, useCallback } from "react";
import { DatePicker, message } from "antd";
import { Chart, Interval, Tooltip, Axis, Geom } from 'bizcharts';
import moment from "moment-timezone";
import {newGetTimeDistance} from "../utils/getTimeDistance";
import { ExplorerClient } from "../proto/sgn/explorer/v1/ExplorerServiceClientPb";
import { GetDailyTransactionVolumeRequest } from "../proto/sgn/explorer/v1/explorer_pb";
import "./dailyTxVolumeChart.less";
import { convertUSD } from "../utils/newFormat";
import { serviceStartTime } from "../constans";

const RangePicker: any = DatePicker.RangePicker;

const axisConfig = {
    line: {
        style: {
            stroke: '#ccc',
            lineDash: [3, 3],
        }, // 设置坐标轴线样式
    },
    grid: {
        line: {
            style: {
                stroke:'#ccc',
                lineDash: [3, 3],
            },
        }, // 设置坐标系栅格样式
    },
};

interface IProps {
    reloadFlag: boolean;
}

const DailyTxVolumeChart = (props: IProps) => {
    const { reloadFlag } = props;
    const [dailyTransactionVolumeList, setDailyTransactionVolumeList] = useState<Array<{
        time: string,
        dailyTransactionVolume: number,
    }>>();
    const [rangePickerValue, setRangePickerValue] = useState<any>(newGetTimeDistance());
    const handleRangePickerChange = (times:any) => {
        if(!times) {
            return;
        }
        const start = times[0];
        const end = times[1];
        start.hours(0);
        start.minutes(0);
        start.seconds(0);
        end.hours(23);
        end.minutes(59);
        end.seconds(59);
        const ary = [start, end];
        setRangePickerValue(ary);
    };

    const getData = useCallback(async () => {
        const start = moment(rangePickerValue[0].valueOf()).format("YYYY-MM-DD HH:mm:ss");
        const end = moment(rangePickerValue[1].valueOf()).format("YYYY-MM-DD HH:mm:ss");
        const utcStart = moment.utc(start).tz("Europe/London").valueOf();
        const utcEnd = moment.utc(end).tz("Europe/London").valueOf();
        const client = new ExplorerClient(`${process.env.REACT_APP_GRPC_SERVER_URL}`, null, null);
        const getDailyTransactionVolumeRequest = new GetDailyTransactionVolumeRequest();
        getDailyTransactionVolumeRequest.setBegin(utcStart);
        getDailyTransactionVolumeRequest.setEnd(utcEnd);
        const res = await client.getDailyTransactionVolume(getDailyTransactionVolumeRequest, null);
        if(res.hasErr()) {
           return message.error(`getDailyTransactionVolumeList Error：${res.getErr()?.getMsg()}`);
        }
        const dailyTransactionVolumeList = res.getDailyTransactionVolumeList();
        const dailyTransactionVolumeListData = dailyTransactionVolumeList?.map((dailyTransactionVolume) => {
            const time = dailyTransactionVolume.getTime();
            const volume = dailyTransactionVolume.getDailyTransactionVolume();
            return {
                time: moment(time).format("MMM DD"),
                dailyTransactionVolume: volume
            }
        })
        setDailyTransactionVolumeList(dailyTransactionVolumeListData);
    }, [rangePickerValue]);

    const disabledDate = (current:any) => {
        // Can not select days after today and today, and can not before serviceStartTime
        return current && (current >= moment().startOf("day") || current < moment(serviceStartTime));
    };

    useEffect(() => {
        getData();
    }, [getData, reloadFlag]);

    return (
        <div className="chart charts-daily-transaction-volume">
            <div className="chart-header">
                <div className="chart-header-title">
                Daily transaction volume
                </div>
                <div className="chart-header-datepicker">
                    <RangePicker
                        value={rangePickerValue}
                        onChange={handleRangePickerChange}
                        onOk={handleRangePickerChange}
                        format="MMM DD,YYYY"
                        disabledDate={disabledDate}
                    />
                </div>
            </div>
            <div className="chart-content">
                <Chart
                    autoFit
                    data={dailyTransactionVolumeList}
                    scale={{ dailyTransactionVolume: {type: 'linear-strict' }}}
                >
                    <Axis
                        name="dailyTransactionVolume"
                        label={{
                            formatter: (val) => convertUSD(val, "round", 0)
                        }}
                        {...axisConfig}
                    />
                    <Interval position="time*dailyTransactionVolume" />
                    <Tooltip/>
                    <Geom
                        type="interval"
                        position="time*dailyTransactionVolume"
                        tooltip={["time*dailyTransactionVolume", (text, dailyTransactionVolume) => {
                            return {
                                name: "Volume",
                                value: convertUSD(dailyTransactionVolume, "round", 0)
                            }
                        }]}
                    />
                </Chart>
            </div>
        </div>
    )
}

export default DailyTxVolumeChart;